import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { colors } from "@/constants/colors.jsx";

const LoanAmountStep = ({ onNext, initialValue = "" }) => {
  const [amount, setAmount] = useState(initialValue);

  return (
    <div className="flex flex-col min-h-[400px] md:min-h-[450px]">
      <div className="space-y-3 mb-6">
        <div className="text-center space-y-1">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900">How much do you want to borrow?</h2>
          <div className="w-12 h-0.5 mx-auto" style={{ backgroundColor: colors.primary[800] }}></div>
        </div>
        <p className="text-gray-600 text-center text-base md:text-lg">It's okay to give an estimated loan amount.</p>
      </div>

      <div className="flex-grow space-y-4">
        <Input 
          type="number"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          placeholder="$"
          className="w-full text-base md:text-lg py-4 md:py-5 px-3 border-slate-200 focus:ring-2"
          style={{ 
            '--ring-color': `${colors.primary[800]}20`,
            '--ring-offset-color': colors.primary[800],
            '&:focus': {
              borderColor: colors.primary[800],
              boxShadow: `0 0 0 2px ${colors.primary[800]}20`
            }
          }}
        />
      </div>

      <div className="mt-auto">
        <Button
          onClick={() => onNext(amount)}
          disabled={!amount}
          className="w-full text-white py-3 md:py-4 text-base md:text-lg font-semibold rounded-lg shadow-md hover:shadow-lg transition-all"
          style={{ 
            backgroundColor: colors.primary[800],
            '&:hover': {
              backgroundColor: `${colors.primary[800]}e6`
            }
          }}
          variant={amount ? "default" : "secondary"}
        >
          Continue
        </Button>
      </div>
    </div>
  );
};

export default LoanAmountStep;